import React from "react";

export const Preloader: React.FC = () => {
  return (
    <div className="flex items-center justify-center w-full py-20">
      <svg
        className="animate-spin"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="24"
          cy="24"
          r="20"
          stroke="rgba(255,255,255,0.08)"
          strokeWidth="4"
        />
        <path
          d="M24 4 A20 20 0 0 1 44 24"
          stroke="#e50914"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
